// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1iz3t","title":"AfterBackImages_title__2gqSk","images":"AfterBackImages_images__3Vohq"};